<script setup lang="ts">
const { open: openFullscreen } = useUiDialog('media-gallery')
</script>

<template>
  <button
    class="media-gallery__enlarge-button"
    :aria-label="$t('Enlarge media gallery')"
    @click="openFullscreen"
  >
    <Icon
      name="icon:enlarge"
      class="icon"
      aria-hidden="true"
    />
  </button>
</template>
